import {
  Button,
  Divider,
  Grid,
  Snackbar,
  Theme,
  useMediaQuery
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import _ from 'lodash';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  getAssigneeRoles,
  getConstructionDetails,
  getConstructionTypes,
  getPrefectureList,
  getScaleList,
  updateConstruction
} from '../apicalls/construction';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import { DatePickerInput } from '../components/atoms';
import LoadingComponent from '../components/LoadingComponent';
import {
  btnColor,
  invalidPhoneNumberRegex,
  isLoggedIn,
  mainBlueColor,
  userRole,
  userMenuId,
  tenantTaxRuleState,
  userSiteManagePlanId,
  unbilledAlerts
} from '../GlobalState';
import { calcTax, formatDatetime } from '../utils/common';
import './List.css';
import { ListButton } from '../components/parts/cloudStorage/style/style';
import { ConstructionSiteImg } from '../components/ConstructionSiteImg';
import { ConstructSiteMap } from '../components/ConstructSiteMap';
import axios from 'axios';
import {
  EXT_INFO_SCREEN_TYPE,
  SITE_MANGE_PLAN_ACCESS_ALLOW
} from '../const/Const';
import { ExtInfoBoxes } from '../components/extInfoBox/ExtInfoBoxes';
import { TInfoBox } from '../types/ExtInfoBox';
import { getExtInfoBoxes } from '../apicalls/extInfoBox';
import { AuthInfoContext } from '../AuthContextProvider';
import { ROLE } from '../const/Const';
import { getUnbilledAlerts } from '../components/topicPath/BillingAlerts';

export const EditConstructionLocation: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [isPhoneNumber] = useRecoilState(invalidPhoneNumberRegex);
  const [userPermission] = useRecoilState(userRole);
  const [userMenu] = useRecoilState(userMenuId);
  const [taxRule] = useRecoilState(tenantTaxRuleState);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      topBoxText: {
        fontSize: 14,
        color: '#000000'
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      table1: {},
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputnew: {
        minHeight: 100,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer2: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 125,
        alignItems: 'center'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        minHeight: 40,
        maxHeight: 80,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        minHeight: 60,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      textContainerPrice: {
        marginLeft: 10,
        marginRight: 13,
        textAlign: 'right',
        width: '100%'
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        minHeight: 48,
        width: '100%'
      },
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputPostalCode: {
        height: 40,
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      tooltip: {
        fontSize: 14
      },
      topContainer: {
        display: 'flex',
        paddingBottom: 15,
        justifyContent: 'space-between'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        marginBottom: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      topColumn: {
        fontSize: 16,
        color: '#000000'
      }
    })
  );

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const classes = useStyles();
  const history: any = useHistory();
  const matches2 = useMediaQuery('(min-width:900px)');
  const [userSiteManagePlan, setUserSiteMangePlan] =
    useRecoilState<any>(userSiteManagePlanId);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [typesData, setTypesData] = useState([]);
  const [scaleData, setScaleData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [prefectureData, setPrefectureData] = useState<
    { name: string; id: number }[]
  >([]);
  const [assigneeRoleData, setAssigneeRoleData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [topConstructionName, setTopConstructionName] = useState(''); // 工事詳細を開いた時のみ変更
  const [topClientName, setTopClientName] = useState(''); // 工事詳細を開いた時のみ変更
  const [isSaved, setIsSaved] = useState<boolean>(true); // 変更内容を保存していない場合False

  const [code, setCode] = useState('');
  const [constructType, setConstructType] = useState<number>(0);
  const [renewStatus, setRenewStatus] = useState<number>(0);
  const [buildingScale, setBuildingScale] = useState<number>(0);
  const [name, setName] = useState('');
  const [sitePrefecture, setSitePrefecture] = useState<number>(0);
  const [sitePrefectureName, setSitePrefectureName] = useState('');
  const [siteAddress1, setSiteAddress1] = useState('');
  const [siteAddress2, setSiteAddress2] = useState('');
  const [siteAddress3, setSiteAddress3] = useState('');
  const site_address = siteAddress1 + siteAddress2 + siteAddress3;
  const [isAddressChanged, setIsAddressChanged] = useState(false);
  const [remarks, setRemarks] = useState<string>('');
  const [contractorPrefecture, setContractorPrefecture] = useState<number>(0);
  const [contractorAddress1, setContractorAddress1] = useState('');
  const [contractorAddress2, setContractorAddress2] = useState('');
  const [contractorAddress3, setContractorAddress3] = useState('');
  const [contractorName, setContractorName] = useState('');
  const [contractorTel, setContractorTel] = useState('');
  const [progress, setProgress] = useState<number>(0);
  const [plannedCost, setPlannedCost] = useState<number>(0);
  const [plannedDays, setPlannedDays] = useState<number>(0);
  const [plannedGrossProfit, setPlannedGrossProfit] = useState<number>(0);
  const [plannedGrossProfitRate, setPlannedGrossProfitRate] =
    useState<number>(0);
  const [smallExpenses, setSmallExpenses] = useState<number>(0);

  const [contractDate, setContractDate] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [billingDate, setBillingDate] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [failureDate, setFailureDate] = useState('');
  const [inspectionDate, setInspectionDate] = useState('');

  const [clientName, setClientName] = useState('');
  const [clientTel, setClientTel] = useState('');
  const [clientPrefecture, setClientPrefecture] = useState('');
  const [clientAddress1, setClientAddress1] = useState('');
  const [clientAddress2, setClientAddress2] = useState('');
  const [clientAddress3, setClientAddress3] = useState('');

  const [contractTaxRate, setContractTaxRate] = useState<number>(10);
  const [selectedTable, setSelectedTable] = useState('estimates');

  const [expectedContractDate, setExpectedContractDate] = useState('');
  const [expectedStartDate, setExpectedStartDate] = useState('');
  const [expectedEndDate, setExpectedEndDate] = useState('');
  const [expectedPaymentDate, setExpectedPaymentDate] = useState('');

  const [loading, setLoading] = useState(true);

  const [itemIds, setItemIds] = useState<any>([]);
  const [itemIds2, setItemIds2] = useState<any>([]);

  const [rowCount, setRowCount] = useState<any>([1]);
  const [rowCount2, setRowCount2] = useState<any>([1]);

  const [assigneeUser, setAssigneeUser] = useState<any>([]);
  const [assigneeRole, setAssigneeRole] = useState<any>([]);
  const [contributionList, setContributionList] = useState<any>([]);
  const [individualSalesList, setIndividualSalesList] = useState<any>([]);
  const [assigneeOutsidePartner, setAssigneeOutsidePartner] = useState<any>([]);
  const [assigneeOutsidePartnerRole, setAssigneeOutsidePartnerRole] =
    useState<any>([]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const [selectedContractDate, setSelectedContractDate] =
    useState<Date | null>(null);
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);
  const [selectedBillingDate, setSelectedBillingDate] =
    useState<Date | null>(null);
  const [selectedPaymentDate, setSelectedPaymentDate] =
    useState<Date | null>(null);
  const [selectedFailureDate, setSelectedFailureDate] =
    useState<Date | null>(null);
  const [selectedInspectionDate, setSelectedInspectionDate] =
    useState<Date | null>(null);
  const [selectedExpectedContractDate, setSelectedExpectedContractDate] =
    useState<Date | null>(null);
  const [selectedExpectedStartDate, setSelectedExpectedStartDate] =
    useState<Date | null>(null);
  const [selectedExpectedEndDate, setSelectedExpectedEndDate] =
    useState<Date | null>(null);
  const [selectedExpectedPaymentDate, setSelectedExpectedPaymentDate] =
    useState<Date | null>(null);

  const [orderAmount, setOrderAmount] = useState<number>(0);
  const [depositAmount, setDepositAmount] = useState<number>(0);
  const [receivableAmount, setReceivableAmount] = useState<number>(0);
  const [materialCost, setMaterialCost] = useState<number>(0);
  const [outsourcingCost, setOutsourcingCost] = useState<number>(0);
  const [executionCost, setExecutionCost] = useState<number>(0);
  const [costDifference, setCostDifference] = useState<number>(0);
  const [grossProfitDifference, setGrossProfitDifference] = useState<number>(0);
  const [grossProfitRateDifference, setGrossProfitRateDifference] =
    useState<number>(0);
  const [execustionGrossProfit, setExecustionGrossProfit] = useState<number>(0);
  const [execustionGrossProfitRate, setExecustionGrossProfitRate] =
    useState<number>(0);
  const [dailyGrossProfit, setDailyGrossProfit] = useState<number>(0);
  const [constructDays, setConstructDays] = useState<number>(0);

  const [companyName, setCompanyName] = useState('');
  const [companyCode, setCompanyCode] = useState('');
  const [companyPostalCode1, setCompanyPostalCode1] = useState('');
  const [companyPostalCode2, setCompanyPostalCode2] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [companyPhoneNumber, setCompanyPhoneNumber] = useState('');
  const [companyFaxNumber, setCompanyFaxNumber] = useState('');
  const [latitude, setLatitude] = useState(35.69575);
  const [longitude, setLongitude] = useState(139.77521);
  const [isMarkerChecked, setIsMarkerChecked] = useState(false);
  const [possibleTime, setPossibleTime] = useState('');
  const [parkSpace, setParkSpace] = useState('');
  const [smokingRule, setSmokingRule] = useState('');
  const [importantOthers, setImportantOthers] = useState('');

  const [janitorName, setJanitorName] = useState('');
  const [janitorPhoneNumber, setJanitorPhoneNumber] = useState('');
  const [janitorFaxNumber, setJanitorFaxNumber] = useState('');
  const [janitorWorkHours, setJanitorWorkHours] = useState<string>('');
  const [janitorOthers, setJanitorOthers] = useState('');
  const [deleteItemList, setDeleteItemList] = useState<any>([]);
  const [smallExpenseItems, setSmallExpenseItems] = useState<any>([]);

  // 選択タブ番号(1:工事情報、2:書類情報、3:現場情報、4:追加情報)
  const [selectTab, setSelectTab] = useState<number>(3);
  //工事番号
  const constructId: number = history.location.state.constructId;
  const [isUpdated, setIsUpdated] = useState<boolean>(false); //保存が実行されたことをConstructionSiteImg.tsxに知らせるためのフラグ

  const [defaultValues, setDefaultValues] = useState<TInfoBox[]>();
  const [, setAlertList] = useRecoilState(unbilledAlerts);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getExtInfoBoxes(constructId, 2).then((data: any) => {
      if (data.data === 'Not logged in!') {
        setOpen(true);
        setErrorMessage(data.data);
      } else {
        if (typeof data.data === 'string') {
          setOpen(true);
          setErrorMessage(data.data);
        } else {
          setDefaultValues(data.data);
        }
      }
    });
  };

  /**
   * 契約日
   */
  const handleContractDateChange = (date: Date | null) => {
    setSelectedContractDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setContractDate(finaldate);
    setIsSaved(false);
  };

  /**
   * 着工日
   */
  const handleStartDateChange = (date: Date | null) => {
    setSelectedStartDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setStartDate(finaldate);
    setIsSaved(false);
  };

  /**
   * 竣工日
   */
  const handleEndDateChange = (date: Date | null) => {
    setSelectedEndDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setEndDate(finaldate);
    setIsSaved(false);
  };

  /**
   * 請求日
   */
  const handleBillingDateChange = (date: Date | null) => {
    setSelectedBillingDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setBillingDate(finaldate);
    setIsSaved(false);
  };

  /**
   * 完工入金日
   */
  const handlePaymentDateChange = (date: Date | null) => {
    setSelectedPaymentDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setPaymentDate(finaldate);
    setIsSaved(false);
  };

  /**
   * 不成立日
   */
  const handleFailureDateChange = (date: Date | null) => {
    setSelectedFailureDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setFailureDate(finaldate);
    setIsSaved(false);
  };

  /**
   * 点検日
   */
  const handleInspectionDateChange = (date: Date | null) => {
    setSelectedInspectionDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setInspectionDate(finaldate);
    setIsSaved(false);
  };

  /**
   * 契約予定日
   */
  const handleExpectedContractDateChange = (date: Date | null) => {
    setSelectedExpectedContractDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setExpectedContractDate(finaldate);
    setIsSaved(false);
  };

  /**
   * 着工予定日
   */
  const handleExpectedStartDateChange = (date: Date | null) => {
    setSelectedExpectedStartDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setExpectedStartDate(finaldate);
    setIsSaved(false);

    let endDate = selectedExpectedEndDate;
    let startDate = date;

    if (endDate !== null && startDate !== null) {
      let diff = endDate?.getTime() - startDate?.getTime();
      let msInDay = 1000 * 3600 * 24;
      setPlannedDays(Math.floor(diff / msInDay));
      setIsSaved(false);
    }
  };

  /**
   * 竣工予定日
   */
  const handleExpectedEndDateChange = (date: Date | null) => {
    setSelectedExpectedEndDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setExpectedEndDate(finaldate);
    setIsSaved(false);

    let endDate = date;
    let startDate = selectedExpectedStartDate;

    if (endDate !== null && startDate !== null) {
      let diff = endDate?.getTime() - startDate?.getTime();
      let msInDay = 1000 * 3600 * 24;
      setPlannedDays(Math.floor(diff / msInDay));
      setIsSaved(false);
    }
  };

  /**
   * 入金予定日
   */
  const handleExpectedPaymentDateChange = (date: Date | null) => {
    setSelectedExpectedPaymentDate(date);
    setIsSaved(false);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setExpectedPaymentDate(finaldate);
    setIsSaved(false);
  };

  const getListOfConstructionTypes = useCallback(() => {
    getConstructionTypes().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setTypesData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfScales = useCallback(() => {
    getScaleList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setScaleData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfAssigneeRoles = useCallback(() => {
    getAssigneeRoles().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setAssigneeRoleData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfPrefectures = useCallback(() => {
    getPrefectureList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setPrefectureData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setUserData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getTheDetailsOfConstrctions = () => {
    getConstructionDetails(history.location.state.constructId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setCode(data.data.code);
            setConstructType(data.data.construct_type);
            setRenewStatus(data.data.renew_status);
            if (data.data.building_scale) {
              setBuildingScale(data.data.building_scale);
            }
            setTopConstructionName(data.data.name);
            setName(data.data.name);
            if (data.data.site_prefecture) {
              setSitePrefecture(data.data.site_prefecture);
            }
            setSiteAddress1(data.data.site_address1);
            setSiteAddress2(data.data.site_address2);
            setSiteAddress3(data.data.site_address3);
            setRemarks(data.data.remarks);

            setContractorPrefecture(data.data.contractor_prefecture);
            setContractorAddress1(data.data.contractor_address1);
            setContractorAddress2(data.data.contractor_address2);
            setContractorAddress3(data.data.contractor_address3);

            setContractorName(data.data.contractor_name);
            setContractorTel(data.data.contractor_tel);
            setProgress(data.data.progress_status);
            if (data.data.planned_cost) {
              setPlannedCost(data.data.planned_cost);
            }
            if (data.data.planned_days) {
              setPlannedDays(data.data.planned_days);
            }
            if (data.data.planned_gross_profit) {
              setPlannedGrossProfit(data.data.planned_gross_profit);
            }
            if (data.data.planned_gross_profit_rate) {
              setPlannedGrossProfitRate(data.data.planned_gross_profit_rate);
            }
            setContractDate(data.data.contract_date);
            if (data.data.contract_date !== '') {
              setSelectedContractDate(new Date(data.data.contract_date));
            }
            setStartDate(data.data.start_date);
            if (data.data.start_date !== '') {
              setSelectedStartDate(new Date(data.data.start_date));
            }
            setEndDate(data.data.end_date);
            if (data.data.end_date !== '') {
              setSelectedEndDate(new Date(data.data.end_date));
            }
            setBillingDate(data.data.billing_date);
            if (data.data.billing_date !== '') {
              setSelectedBillingDate(new Date(data.data.billing_date));
            }
            setPaymentDate(data.data.payment_date);
            if (data.data.payment_date !== '') {
              setSelectedPaymentDate(new Date(data.data.payment_date));
            }
            setFailureDate(data.data.failure_date);
            if (data.data.failure_date !== '') {
              setSelectedFailureDate(new Date(data.data.failure_date));
            }
            setInspectionDate(data.data.inspection_date);
            if (data.data.inspection_date !== '') {
              setSelectedInspectionDate(new Date(data.data.inspection_date));
            }
            setContractTaxRate(data.data.contract_tax_rate);
            setExpectedContractDate(data.data.expected_contract_date);
            if (data.data.expected_contract_date !== '') {
              setSelectedExpectedContractDate(
                new Date(data.data.expected_contract_date)
              );
            }
            setExpectedStartDate(data.data.expected_start_date);
            if (data.data.expected_start_date !== '') {
              setSelectedExpectedStartDate(
                new Date(data.data.expected_start_date)
              );
            }
            setExpectedEndDate(data.data.expected_end_date);
            if (data.data.expected_end_date !== '') {
              setSelectedExpectedEndDate(new Date(data.data.expected_end_date));
            }
            setExpectedPaymentDate(data.data.expected_payment_date);
            if (data.data.expected_payment_date) {
              setSelectedExpectedPaymentDate(
                new Date(data.data.expected_payment_date)
              );
            }
            if (data.data.small_expenses && data.data.small_expenses !== '') {
              setSmallExpenses(data.data.small_expenses);
            }
            if (data.data.small_expense_items.length > 0) {
              let items = [...data.data.small_expense_items];
              // 小口経費明細ができる前のデータをGetすると、nameにnullが入って、保存時にエラーになる為。
              if (items[0].name === null) {
                items[0].name = '';
              }
              setSmallExpenseItems(items);
              let priceArray: number[] = [];
              items.map(item => priceArray.push(item.price));
              let totalPrice: number = priceArray.reduce((a, b) => a + b);
              setSmallExpenses(totalPrice);
            }
            setTopClientName(data.data.client_name);
            setClientName(data.data.client_name);
            setClientName(data.data.client_name);
            setClientTel(data.data.client_tel);
            setClientPrefecture(data.data.client_prefecture);
            setClientAddress1(data.data.client_address1);
            setClientAddress2(data.data.client_address2);
            setClientAddress3(data.data.client_address3);

            setOrderAmount(data.data.order_amount);
            setDepositAmount(data.data.deposit_amount);
            setReceivableAmount(data.data.receivable_amount);
            setMaterialCost(data.data.material_cost);
            setOutsourcingCost(data.data.outsourcing_cost);
            setExecutionCost(data.data.execution_cost);
            setCostDifference(data.data.cost_difference);
            setGrossProfitDifference(data.data.gross_profit_difference);
            setGrossProfitRateDifference(
              data.data.gross_profit_rate_difference
            );
            setExecustionGrossProfit(data.data.execustion_gross_profit);
            setExecustionGrossProfitRate(
              data.data.execustion_gross_profit_rate
            );
            setDailyGrossProfit(data.data.daily_gross_profit);
            setCompanyName(data.data.company_name);
            setCompanyCode(data.data.company_code);
            setCompanyPostalCode1(data.data.company_postal_code.slice(0, 3));
            setCompanyPostalCode2(data.data.company_postal_code.slice(-4));
            setCompanyAddress(data.data.company_address);
            setCompanyPhoneNumber(data.data.company_phone_number);
            setCompanyFaxNumber(data.data.company_fax_number);
            setLatitude(data.data.latitude);
            setLongitude(data.data.longitude);
            setIsMarkerChecked(data.data.is_marker_checked);
            setPossibleTime(data.data.possible_time);
            setParkSpace(data.data.park_space);
            setSmokingRule(data.data.smoking_rule);
            setImportantOthers(data.data.important_others);
            setJanitorName(data.data.janitor_name);
            setJanitorPhoneNumber(data.data.janitor_phone_number);
            setJanitorFaxNumber(data.data.janitor_fax_number);
            setJanitorWorkHours(data.data.janitor_work_hours);
            setJanitorOthers(data.data.janitor_others);
            setConstructDays(data.data.construct_days);
            let iIds: any = [];
            let iIds2: any = [];
            let iRowCount: any = rowCount;
            let iRowCount2: any = rowCount2;
            let iAssigneeUser: any = [];
            let iAssigneeRole: any = [];
            let iContributionList: any = [];
            let iIndividualSalesList: any = [];
            let iAssigneeOutsidePartner: any = [];
            let iAssigneeOutsidePartnerRole: any = [];
            data.data.assignee_list.map((k: any, index: number) => {
              if (k.assignee_role !== 5) {
                // 担当者
                if (index === 0) {
                  setRowCount(iRowCount);
                } else {
                  iRowCount.push(1);
                  setRowCount(iRowCount);
                }
                iIds.push(k.id);
                iAssigneeUser.push(k.assignee_user);
                setAssigneeUser(iAssigneeUser);
                iAssigneeRole.push(k.assignee_role);
                setAssigneeRole(iAssigneeRole);

                iContributionList.push(parseFloat(k.contribution));
                setContributionList(iContributionList);

                iIndividualSalesList.push(
                  (parseFloat(k.contribution) * data.data.order_amount) / 100
                );
                setIndividualSalesList(iIndividualSalesList);
              } else {
                // 社外パートナー
                iRowCount2.push(1);
                setRowCount2(iRowCount2);
                iIds2.push(k.id);
                iAssigneeOutsidePartner.push(k.assignee_user);
                setAssigneeOutsidePartner(iAssigneeOutsidePartner);
                iAssigneeOutsidePartnerRole.push(k.assignee_role);
                setAssigneeOutsidePartnerRole(iAssigneeOutsidePartnerRole);
              }
              return <></>;
            });

            setItemIds(iIds);
            setItemIds2(iIds2);
            setLoading(false);
          }
        }
      }
    });
  };

  useEffect(() => {
    getListOfConstructionTypes();
    getListOfScales();
    getListOfPrefectures();
    getListOfUsers();
    getListOfAssigneeRoles();
    getTheDetailsOfConstrctions();
    // 無限ループになるためgetTheDetailsOfConstructionsを除外
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getListOfConstructionTypes,
    getListOfScales,
    getListOfPrefectures,
    getListOfUsers,
    getListOfAssigneeRoles
  ]);

  useEffect(() => {
    setReceivableAmount(
      orderAmount +
        calcTax(orderAmount, contractTaxRate / 100, taxRule) -
        depositAmount
    );
  }, [orderAmount, contractTaxRate, depositAmount, receivableAmount]);

  const updateConstructionDetails = () => {
    let small_expense_item: any = [];
    for (let n = 0; n < smallExpenseItems.length; n++) {
      if (
        smallExpenseItems[n].price !== '' &&
        smallExpenseItems[n].name.length <= 30
      ) {
        small_expense_item[n] = {
          name: smallExpenseItems[n].name,
          price: smallExpenseItems[n].price,
          id: smallExpenseItems[n].id
        };
      } else if (smallExpenseItems[n].name.length > 30) {
        setErrorMessage('経費項目は30文字以内で入力してください。');
        setOpen(true);
        return;
      } else if (smallExpenseItems[n].price === '') {
        setErrorMessage('金額を入力してください。');
        setOpen(true);
        return;
      }
    }
    setSmallExpenseItems(small_expense_item);

    let contriSum = 0;
    for (let i = 0; i < contributionList.length; i++) {
      contriSum += contributionList[i];
    }
    if (code.trim() === '') {
      setErrorMessage('工事番号を入力してください。');
      setOpen(true);
    } else if (code.length > 10) {
      setErrorMessage('工事番号は10文字以内で記入してください。');
      setOpen(true);
    } else if (constructType === 0 || !constructType) {
      setErrorMessage('案件種別を選択してください。');
      setOpen(true);
    } else if (renewStatus === 0) {
      setErrorMessage('「新規」または「リピート」を選択してください。');
      setOpen(true);
    } else if (name.trim() === '') {
      setErrorMessage('工事件名を入力してください。');
      setOpen(true);
    } else if (name.length > 60) {
      setErrorMessage('工事件名は60文字以内で記入してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && progress === 0) {
      setErrorMessage('進行状況を入力してください。');
      setOpen(true);
    } else if (
      contractorTel.trim() !== '' &&
      (isPhoneNumber.test(contractorTel.trim()) ||
        contractorTel.trim().length > 20)
    ) {
      setErrorMessage('契約者TELが無効です。');
      setOpen(true);
    } else if (userMenu != 'Storage' && assigneeUser.length === 0) {
      setErrorMessage('担当者名を入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && assigneeRole.length === 0) {
      setErrorMessage('担当役割を入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && contributionList.length === 0) {
      setErrorMessage('貢献度を入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && contriSum !== 100) {
      setErrorMessage('貢献度の合計は100％でなければなりません');
      setOpen(true);
    } else if (companyName.length > 30) {
      setErrorMessage('会社名は30文字以内で入力してください。');
      setOpen(true);
    } else if (
      companyPhoneNumber.trim() !== '' &&
      (isPhoneNumber.test(companyPhoneNumber.trim()) ||
        companyPhoneNumber.trim().length > 20)
    ) {
      setErrorMessage('無効な電話番号です。');
      setOpen(true);
    } else if (
      companyPostalCode1 !== '' &&
      companyPostalCode2 !== '' &&
      (companyPostalCode1.length !== 3 || companyPostalCode2.length !== 4)
    ) {
      setErrorMessage('郵便番号の形式が間違っています。');
      setOpen(true);
    } else if (companyAddress.length > 60) {
      setErrorMessage('所在地は60文字以内で入力してください。');
      setOpen(true);
    } else if (possibleTime.length > 200) {
      setErrorMessage('工事可能時間は200文字以内で入力してください。');
      setOpen(true);
    } else if (parkSpace.length > 200) {
      setErrorMessage('駐車スペースは200文字以内で入力してください。');
      setOpen(true);
    } else if (smokingRule.length > 200) {
      setErrorMessage('喫煙ルールは200文字以内で入力してください。');
      setOpen(true);
    } else if (importantOthers.length > 200) {
      setErrorMessage(
        '施工に関する注意点：その他は200文字以内で入力してください。'
      );
      setOpen(true);
    } else if (janitorName.length > 200) {
      setErrorMessage('管理人名は200文字以内で入力してください。');
      setOpen(true);
    } else if (
      janitorPhoneNumber.trim() !== '' &&
      (isPhoneNumber.test(janitorPhoneNumber.trim()) ||
        janitorPhoneNumber.trim().length > 20)
    ) {
      setErrorMessage('管理人TELが無効です。');
      setOpen(true);
    } else if (janitorFaxNumber.length > 20) {
      setErrorMessage('管理人FAXは20文字以内で入力してください。');
      setOpen(true);
    } else if (janitorWorkHours.length > 200) {
      setErrorMessage(
        '管理会社情報：勤務時間は200文字以内で入力してください。'
      );
      setOpen(true);
    } else if (janitorOthers.length > 200) {
      setErrorMessage('管理会社情報：その他は200文字以内で入力してください。');
      setOpen(true);
    } else if (siteAddress1.length > 10) {
      setErrorMessage('現場住所/市町村区は10文字以内で入力してください。');
      setOpen(true);
    } else if (siteAddress2.length > 20) {
      setErrorMessage('現場住所/町名・番地は20文字以内で入力してください。');
      setOpen(true);
    } else if (siteAddress3.length > 30) {
      setErrorMessage(
        '現場住所/現場住所建物名/部屋番号は30文字以内で入力してください。'
      );
      setOpen(true);
    } else {
      let l1 = assigneeUser.length;
      let l2 = assigneeRole.length;
      let l3 = contributionList.length;
      let l4 = individualSalesList.length;
      let l5 = assigneeOutsidePartner.length;
      let l6 = assigneeOutsidePartnerRole.length;

      let flag = false;
      if (l1 === l2 && l2 === l3 && l3 === l4) {
        flag = true;
      }
      // 保存前のデータチェック用の配列
      let items: any = [];
      if (flag === true) {
        for (let i = 0; i < assigneeUser.length; i++) {
          let lenName = assigneeUser.length;
          let lenId = itemIds.length;
          let newArr1 = Array(lenName - lenId).fill(0);
          let concatArray1 = itemIds;
          let concatArray2 = concatArray1.concat(newArr1);
          setItemIds(concatArray2);

          items[i] = {
            id: concatArray2[i],
            assignee_user: assigneeUser[i],
            assignee_role: assigneeRole[i],
            contribution: contributionList[i],
            individual_sales: individualSalesList[i]
          };

          if (deleteItemList) {
            items.push(...deleteItemList);
          }
        }

        let arr: any = [];
        for (let n = 0; n < items.length; n++) {
          if (
            items[n].assignee_user ||
            items[n].assignee_role ||
            items[n].contribution ||
            items[n].individual_sales
          ) {
            arr.push(items[n]);
          }
        }

        // 社外パートナー
        let flag2 = false;
        if (l5 === l6) {
          flag2 = true;
        }
        let items2: any = [];
        if (flag2 === true) {
          for (let i = 0; i < assigneeOutsidePartner.length; i++) {
            let lenName2 = assigneeOutsidePartner.length;
            let lenId2 = itemIds2.length;
            let newArr2 = Array(lenName2 - lenId2).fill(0);
            let concatArray3 = itemIds2;
            let concatArray4 = concatArray3.concat(newArr2);
            setItemIds2(concatArray4);

            items2[i] = {
              id: concatArray4[i],
              assignee_user: assigneeOutsidePartner[i],
              assignee_role: assigneeOutsidePartnerRole[i],
              contribution: 0,
              individual_sales: 0
            };
          }

          let arr2: any = [];
          for (let n = 0; n < assigneeOutsidePartner.length; n++) {
            if (items2[n].assignee_user || items2[n].assignee_role) {
              arr2.push(items2[n]);
            }
          }
          updateFunction(arr, arr2);
        } else {
          setErrorMessage('社外パートナー情報を設定してください。');
          setOpen(true);
        }
      } else {
        setErrorMessage('担当者を設定してください。');
        setOpen(true);
      }
    }
  };

  const updateFunction = (newAssigneeArr: any, newOutsidePartnerArr: any) => {
    setIsSaved(true);
    updateConstruction(
      history.location.state.constructId,
      code.trim(),
      constructType,
      renewStatus,
      buildingScale,
      name.trim(),
      sitePrefecture,
      siteAddress1.trim(),
      siteAddress2.trim(),
      siteAddress3.trim(),
      remarks,
      contractorPrefecture,
      contractorAddress1.trim(),
      contractorAddress2.trim(),
      contractorAddress3.trim(),
      contractorName.trim(),
      contractorTel.trim(),
      progress,
      plannedCost,
      plannedDays,
      plannedGrossProfit,
      selectedContractDate !== null ? contractDate : '',
      selectedStartDate !== null ? startDate : '',
      selectedEndDate !== null ? endDate : '',
      selectedBillingDate !== null ? billingDate : '',
      selectedPaymentDate !== null ? paymentDate : '',
      selectedFailureDate !== null ? failureDate : '',
      selectedInspectionDate !== null ? inspectionDate : '',
      contractTaxRate,
      selectedExpectedContractDate !== null ? expectedContractDate : '',
      selectedExpectedStartDate !== null ? expectedStartDate : '',
      selectedExpectedEndDate !== null ? expectedEndDate : '',
      selectedExpectedPaymentDate !== null ? expectedPaymentDate : '',
      smallExpenses,
      newAssigneeArr,
      newOutsidePartnerArr,
      companyName.trim(),
      String(companyCode.trim()),
      String(companyPostalCode1.trim()) + String(companyPostalCode2.trim()),
      companyAddress.trim(),
      String(companyPhoneNumber.trim()),
      String(companyFaxNumber.trim()),
      latitude,
      longitude,
      isMarkerChecked,
      possibleTime.trim(),
      parkSpace.trim(),
      smokingRule.trim(),
      importantOthers.trim(),
      janitorName.trim(),
      janitorPhoneNumber.trim(),
      janitorFaxNumber.trim(),
      janitorWorkHours.trim(),
      janitorOthers.trim(),
      smallExpenseItems
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setIsUpdated(true);
            getUnbilledAlerts(setAlertList);
          }
        }
      }
    });
  };

  /**
   * googleMapへのURLの作成時に、sitePrefectureがnumberで使えないため作成
   * @param id
   */
  const changeSitePrefectureName = (id: number) => {
    const prefecture = prefectureData.filter(pref => pref.id === id);

    if (prefecture.length === 1) {
      setSitePrefectureName(prefecture[0]['name']);
    } else {
      setSitePrefectureName('');
    }
  };

  useEffect(() => {
    changeSitePrefectureName(sitePrefecture);
  }, [sitePrefecture]);

  const convertToLatLong = async (force: boolean = false) => {
    if (isAddressChanged || force) {
      setIsAddressChanged(false);
      return axios
        .get(`/api/v1/constructions/site_address/${site_address}`, {
          headers: {
            withCredentials: true
          }
        })
        .then(response => {
          //googleMapの緯度経度が小数点7桁までなので8桁以降を切り捨て
          //国内は緯度は小数点以上が２桁、経度は3桁
          setLatitude(Number(response.data.latitude.toFixed(5)));
          setLongitude(Number(response.data.longitude.toFixed(5)));
        })
        .catch(err => {
          return err.response;
        });
    }
  };

  const resetIsUpdated = () => {
    setIsUpdated(false);
  };

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent patternName='constructions_edit' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>
              <div className='table-top-container-customer'>
                <div style={{ fontWeight: 'bold' }}>
                  <Button
                    style={{
                      minWidth: 90,
                      marginRight: 15,
                      color: '#758283',
                      backgroundColor: '#F5F5F5',
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => history.goBack()}
                    startIcon={<ArrowBackIcon />}
                  >
                    戻る
                  </Button>
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: '#FFFFFF' }}>
              <div className={classes.topContainer}>
                <div
                  style={{
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    marginLeft: 15,
                    marginTop: 24
                  }}
                >
                  <div style={{ fontSize: 18 }}>{topConstructionName}</div>
                  <div style={{ fontSize: 14, fontWeight: 'lighter' }}>
                    {topClientName}
                  </div>
                </div>
                <div>
                  {userMenu != 'BM' && (
                    <>
                      {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                        <ListButton
                          variant='contained'
                          style={{ marginRight: 12, marginTop: 24 }}
                          onClick={() => {
                            history.push(`/files`, {
                              state: {
                                id: history.location.state.constructId,
                                name: name
                              }
                            });
                          }}
                        >
                          資料一覧
                        </ListButton>
                      )}
                      <ListButton
                        variant='contained'
                        style={{ marginRight: 12, marginTop: 24 }}
                        onClick={() => {
                          history.push(`/pictures`, {
                            state: {
                              id: history.location.state.constructId,
                              name: name
                            }
                          });
                        }}
                      >
                        写真一覧
                      </ListButton>
                    </>
                  )}
                  {/* NOTE: メニュー出し分けリリースまでの暫定対応 */}
                  {userSiteManagePlan != 99 && (
                    <ListButton
                      variant='contained'
                      style={{ marginRight: 15, marginTop: 24 }}
                      onClick={() => {
                        history.push(`/processes`, {
                          constructId: history.location.state.constructId,
                          name: topConstructionName
                        });
                      }}
                    >
                      工程表
                    </ListButton>
                  )}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: matches2 ? 'row' : 'column'
                }}
                className={classes.topList}
              >
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ width: 15 }}
                ></div>
                <div
                  onClick={() => {
                    if (isSaved == true) {
                      history.push(
                        `/constructions/${history.location.state.constructId}/edit`,
                        {
                          state: history.location.state.constructId
                        }
                      );
                    } else {
                      setErrorMessage('保存してください。');
                      setOpen(true);
                    }
                  }}
                  className='border2'
                >
                  <div className={classes.topColumn}>工事情報</div>
                </div>
                {/* 業務管理を使用しないテナントには書類情報タブを表示しない */}
                {userMenu !== 'Storage' &&
                  userMenu !== 'SiteManage' &&
                  authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <div
                      onClick={() => {
                        if (isSaved == true) {
                          history.push(
                            `/constructions_document/${history.location.state.constructId}/edit`,
                            {
                              constructId: history.location.state.constructId
                            }
                          );
                        } else {
                          setErrorMessage('保存してください。');
                          setOpen(true);
                        }
                      }}
                      className='border2'
                    >
                      <div className={classes.topColumn}>書類情報</div>
                    </div>
                  )}
                {/* ストレージのみのテナントには現場情報タブを表示しない */}
                {userMenu !== 'Storage' && (
                  <div
                    onClick={() => setSelectTab(3)}
                    className='border2'
                    style={{
                      backgroundColor: selectTab == 3 ? '#F5F5F5' : '#ffffff',
                      borderTopColor: selectTab == 3 ? '#0099CB' : '#cccccc',
                      borderBottom:
                        selectTab == 3 ? 'none' : 'solid 1px #cccccc',
                      width: 200
                    }}
                  >
                    <div
                      className={classes.topColumn}
                      style={{ color: selectTab == 3 ? '#0099CB' : '#000000' }}
                    >
                      現場情報
                    </div>
                  </div>
                )}
                {authInfo?.role != ROLE['OUTSIDE_PARTNER'] &&
                  defaultValues &&
                  defaultValues.length > 0 && (
                    <div
                      onClick={() => setSelectTab(4)}
                      className='border2'
                      style={{
                        backgroundColor: selectTab == 4 ? '#F5F5F5' : '#ffffff',
                        borderTopColor: selectTab == 4 ? '#0099CB' : '#cccccc',
                        borderBottom:
                          selectTab == 4 ? 'none' : 'solid 1px #cccccc',
                        width: 200
                      }}
                    >
                      <div
                        className={classes.topColumn}
                        style={{
                          color: selectTab == 4 ? '#0099CB' : '#000000'
                        }}
                      >
                        追加情報
                      </div>
                    </div>
                  )}
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
            </div>

            {/** 現場情報の場合 */}
            {selectTab == 3 && (
              <>
                <>
                  <div style={{ margin: 15 }}>
                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div
                        style={{
                          fontWeight: 'bold',
                          padding: 15,
                          paddingBottom: 0,
                          fontSize: 24
                        }}
                      >
                        スケジュール
                      </div>
                    </div>
                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        paddingBottom: 15,
                        marginBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 4 : 12}>
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>契約日</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedContractDate}
                                onChange={handleContractDateChange}
                                id={'contract_date'}
                                emptyLabel='連絡日'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>着工日</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedStartDate}
                                onChange={handleStartDateChange}
                                id={'start_date'}
                                emptyLabel='連絡日'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>竣工日</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedEndDate}
                                onChange={handleEndDateChange}
                                id={'end_date'}
                                emptyLabel='日付を選択'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>請求日</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedBillingDate}
                                onChange={handleBillingDateChange}
                                id={'billing_date'}
                                emptyLabel='日付を選択'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              完工入金日
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedPaymentDate}
                                onChange={handlePaymentDateChange}
                                id={'payment_date'}
                                emptyLabel='日付を選択'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              不成立日
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedFailureDate}
                                onChange={handleFailureDateChange}
                                id={'failure_date'}
                                emptyLabel='日付を選択'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>点検日</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedInspectionDate}
                                onChange={handleInspectionDateChange}
                                id={'inspection_date'}
                                emptyLabel='日付を選択'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>
                      <Grid item xs={matches2 ? 4 : 12}>
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              契約予定日
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedExpectedContractDate}
                                onChange={handleExpectedContractDateChange}
                                id={'expected_contract_date'}
                                emptyLabel='日付を選択'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              着工予定日
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedExpectedStartDate}
                                onChange={handleExpectedStartDateChange}
                                id={'expected_contract_date'}
                                emptyLabel='日付を選択'
                                maxDate={
                                  selectedExpectedEndDate
                                    ? selectedExpectedEndDate
                                    : undefined
                                }
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              竣工予定日
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedExpectedEndDate}
                                onChange={handleExpectedEndDateChange}
                                id={'expected_end_date'}
                                emptyLabel='日付を選択'
                                minDate={
                                  selectedExpectedStartDate
                                    ? selectedExpectedStartDate
                                    : undefined
                                }
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              入金予定日
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                marginLeft: 10,
                                marginRight: 15,
                                backgroundColor: '#FFFFFF',
                                height: 42,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                width: '100%'
                              }}
                              className={'select-div-div'}
                            >
                              <DatePickerInput
                                date={selectedExpectedPaymentDate}
                                onChange={handleExpectedPaymentDateChange}
                                id={'expected_payment_date'}
                                emptyLabel='日付を選択'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>
                      <Grid item xs={matches2 ? 4 : 12}>
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              進行状況<span>*</span>
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={progress}
                                onChange={e => {
                                  setProgress(parseInt(e.target.value));
                                  setIsSaved(false);
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              >
                                <option value={0}>進行状況</option>
                                <option value={1}>未契約</option>
                                <option value={2}>営業中(Aランク)</option>
                                <option value={3}>営業中(Bランク)</option>
                                <option value={4}>営業中(Cランク)</option>
                                <option value={5}>契約</option>
                                <option value={6}>工事中</option>
                                <option value={7}>竣工</option>
                                <option value={8}>引渡</option>
                                <option value={9}>入金・完工</option>
                                <option value={10}>不成立</option>
                                <option value={11}>是正</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              契約書用税率（%）
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={contractTaxRate}
                                onChange={e => {
                                  setContractTaxRate(parseInt(e.target.value));
                                  setIsSaved(false);
                                }}
                                className={classes.selectBoxStyle}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              >
                                <option value={10}>10</option>
                                <option value={0}>0</option>
                                {/* <option value={5}>5</option> */}
                                <option value={8}>8</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>
                    </Grid>
                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div
                        style={{
                          fontWeight: 'bold',
                          padding: 15,
                          paddingBottom: 0,
                          fontSize: 24
                        }}
                      >
                        現場情報
                      </div>
                    </div>
                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        paddingBottom: 15,
                        marginBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 4 : 12}>
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              現場住所/都道府県
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={sitePrefecture}
                                onChange={e => {
                                  setSitePrefecture(parseInt(e.target.value));
                                  setIsSaved(false);
                                  setIsAddressChanged(true);
                                  setIsMarkerChecked(false);
                                }}
                                onBlur={() => {
                                  convertToLatLong();
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              >
                                <option value={0}>選択してください</option>
                                {prefectureData.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              現場住所/市区町村
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={siteAddress1}
                                onChange={e => {
                                  setSiteAddress1(e.target.value);
                                  setIsSaved(false);
                                  setIsAddressChanged(true);
                                  setIsMarkerChecked(false);
                                }}
                                onBlur={() => {
                                  convertToLatLong();
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              現場住所/町名・番地
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={siteAddress2}
                                onChange={e => {
                                  setSiteAddress2(e.target.value);
                                  setIsSaved(false);
                                  setIsAddressChanged(true);
                                  setIsMarkerChecked(false);
                                }}
                                onBlur={() => {
                                  convertToLatLong();
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div
                          className={classes.subContainer}
                          style={{ marginBottom: 15 }}
                        >
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              現場住所建物名/部屋番号など
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={siteAddress3}
                                onChange={e => {
                                  setSiteAddress3(e.target.value);
                                  setIsSaved(false);
                                  setIsAddressChanged(true);
                                  setIsMarkerChecked(false);
                                }}
                                onBlur={() => {
                                  convertToLatLong();
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={matches2 ? 4 : 12}>
                        <ConstructSiteMap
                          latitude={latitude}
                          longitude={longitude}
                          setLatitude={setLatitude}
                          setLongitude={setLongitude}
                          convertToLatLng={convertToLatLong}
                          isMarkerChecked={isMarkerChecked}
                          setIsMarkerChecked={setIsMarkerChecked}
                          userRoleId={authInfo?.role}
                        />
                      </Grid>
                      <Grid item xs={matches2 ? 4 : 12}>
                        <ConstructionSiteImg
                          isPosted={false}
                          isUpdated={isUpdated}
                          construct_id={constructId}
                          setOpen={setOpen}
                          setErrorMessage={setErrorMessage}
                          resetIsUpdated={resetIsUpdated}
                        />
                      </Grid>
                    </Grid>
                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div className='question-position'>
                        <div
                          style={{
                            fontWeight: 'bold',
                            padding: 15,
                            paddingBottom: 0,
                            paddingRight: 0,
                            fontSize: 24
                          }}
                        >
                          施工に関する注意点
                        </div>
                      </div>
                    </div>
                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        paddingBottom: 15,
                        marginBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 4 : 12}>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer1}>
                            <div className={classes.textContainer1}>
                              工事可能時間
                            </div>
                          </div>
                          <div className={classes.inputMainContainer1}>
                            <div className={classes.inputContainer}>
                              <textarea
                                value={possibleTime}
                                onChange={text => {
                                  setPossibleTime(text.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              駐車スペース
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <textarea
                                value={parkSpace}
                                onChange={text => {
                                  setParkSpace(text.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              喫煙ルール
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <textarea
                                value={smokingRule}
                                onChange={text => {
                                  setSmokingRule(text.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>その他</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <textarea
                                value={importantOthers}
                                onChange={text => {
                                  setImportantOthers(text.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </Grid>
                    </Grid>

                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div className='question-position'>
                        <div
                          style={{
                            fontWeight: 'bold',
                            padding: 15,
                            paddingBottom: 0,
                            paddingRight: 0,
                            fontSize: 24
                          }}
                        >
                          管理会社情報
                        </div>
                      </div>
                    </div>
                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        paddingBottom: 15,
                        marginBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 4 : 12}>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              管理人名
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={janitorName}
                                type='text'
                                onChange={text => {
                                  setJanitorName(text.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              管理人TEL
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={janitorPhoneNumber}
                                type='text'
                                onChange={text => {
                                  setJanitorPhoneNumber(text.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              管理人FAX
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={janitorFaxNumber}
                                type='text'
                                onChange={text => {
                                  setJanitorFaxNumber(text.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              勤務時間
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <textarea
                                value={janitorWorkHours}
                                onChange={text => {
                                  setJanitorWorkHours(text.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>その他</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <textarea
                                value={janitorOthers}
                                onChange={text => {
                                  setJanitorOthers(text.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </>
                {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                  <>
                    <div style={{ height: 80 }} />
                    <div
                      className='save-btn-container'
                      style={{
                        backgroundColor: '#FFFFFF',
                        position: 'fixed',
                        bottom: 0,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-around'
                      }}
                    >
                      <div />
                      <div>
                        <Button
                          onClick={updateConstructionDetails}
                          style={{
                            paddingLeft: 50,
                            paddingRight: 50,
                            margin: 20,
                            backgroundColor: buttonColor
                          }}
                          variant='contained'
                          color='primary'
                        >
                          保存
                        </Button>
                      </div>
                      <div />
                    </div>
                  </>
                )}
              </>
            )}

            {/** 追加情報の場合 */}
            {selectTab == 4 && defaultValues && defaultValues.length > 0 && (
              <>
                <ExtInfoBoxes
                  defaultValues={defaultValues}
                  targetId={constructId}
                  ext_info_screen_type={EXT_INFO_SCREEN_TYPE.CONSTRUCT}
                  setOpen={setOpen}
                  setOpenSuccess={setOpenSuccess}
                  setErrorMessage={setErrorMessage}
                  getData={getData}
                />
                <div style={{ height: 80 }} />
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};
